import { render, staticRenderFns } from "./CustomerAutomation.vue?vue&type=template&id=3e6c2a9e&scoped=true&"
import script from "./CustomerAutomation.vue?vue&type=script&lang=js&"
export * from "./CustomerAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6c2a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e6c2a9e')) {
      api.createRecord('3e6c2a9e', component.options)
    } else {
      api.reload('3e6c2a9e', component.options)
    }
    module.hot.accept("./CustomerAutomation.vue?vue&type=template&id=3e6c2a9e&scoped=true&", function () {
      api.rerender('3e6c2a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMenu/CustomerAutomation.vue"
export default component.exports